import axios from '@/axios.js'

export default {
    getUsers: async (appUuid, parameters) => {
        try {
            const response = await axios.editorapi.get(`v4/apps/${appUuid}/users`, { params: parameters })
            return response.data.object
        } catch (error) {
            throw new Error(error)
        }
    },
    getUser: async (appUuid, userUuid) => {
        const response = await axios.editorapi.get(`v4/apps/${appUuid}/users/${userUuid}`)
        return response.data.object
    },
    editUser: async (appUuid, userUuid, data) => {
        const response = await axios.editorapi.patch(`v4/apps/${appUuid}/users/${userUuid}`, data)
        return response.data
    },
    sendRestorePasswordEmail: async (appUuid, userUuid) => {
        const response = await axios.editorapi.post(`v4/apps/${appUuid}/users/${userUuid}/send-restore-password`)
        return response.data
    },
    deleteUser: async (appUuid, userUuid) => {
        const response = await axios.editorapi.delete(`v4/apps/${appUuid}/users/${userUuid}`)
        return response.data
    },
    exportUsers: async (appUuid, parameters) => {
        try {
            const params = { ...parameters, type: 'csv' }
            const response = await axios.editorapi.get(`v4/apps/${appUuid}/export/users`, { params: params })
            return response.data.object
        } catch (error) {
            throw new Error(error)
        }
    },
}